import { ProductKey } from 'src/shared/types/engine/products';
import { ProductAccess } from 'src/shared/types/productLicensing';
import useProject from './useProject';
import { useProductAccess } from './useProductLicensing';

/**
 * Whether the current site has Habitat Insights results. `undefined` until the
 * site definition loads, so access is `LOADING` in that window rather than the
 * upsell page on a paying site.
 */
export const useHasHabitatInsightsResults = (): boolean | undefined => {
    const { projectDefinition, isHabitatInsightsProject } = useProject();

    return projectDefinition ? isHabitatInsightsProject : undefined;
};

/** How much of Habitat Insights the current user may see on the current site. */
const useHabitatInsightsAccess = (): ProductAccess => useProductAccess(ProductKey.HABITAT_INSIGHTS, useHasHabitatInsightsResults());

export default useHabitatInsightsAccess;
